const styles = () => ({
  rootDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "75%",
    marginTop: "100px",
  },
  secondDiv: {
    position: "relative",
  },
  circularProgress: {
    color: "#0445EE",
    animationDuration: "2000ms",
    position: "absolute",
    left: 50,
    top: 100,
  },
  logo: {
    position: "absolute",
    left: 80,
    top: 130,
  },
});

export default styles;
